import {
  RejectedNoShadow as RejectedNoShadowIcon,
  Cover as CoverIcon,
  Hourglass as HourglassIcon,
  VideoFailed as VideoFailedIcon,
  PendingNoShadow as PendingNoShadowIcon,
} from 'common/components/svgs';
import React from 'react';
import {
  DeleteOutlined,
  EyeOutlined,
  PauseOutlined,
  PlayCircleOutlined,
  ReloadOutlined,
  RightOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons';
import { Tooltip, Select } from 'antd';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import gallery, { localeMapping, uploadStatus } from '~constants/gallery';
import { propertyDraftStatus } from '~constants/pending-approval';
import ProgressBar from '~components/property-gallery/progress-bar';

const { Option } = Select;

export default class PhotoItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      eyeShow: false,
      uploadState: props.uploadState,
      progress: props.progress,
      transcodedStatus: props.transcodedStatus,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.uploadState !== this.state.uploadState ||
      nextProps.progress !== this.state.progress ||
      nextProps.transcodedStatus !== this.state.transcodedStatus
    ) {
      this.setProgress(nextProps.uploadState, nextProps.progress, nextProps.transcodedStatus);
    }
  }

  setProgress(uploadState, progress, transcodedStatus) {
    this.setState({
      uploadState,
      progress,
      transcodedStatus,
    });
  }

  toggleHideEye = () => {
    this.setState({
      eyeShow: false,
    });
  };

  toggleShowEye = () => {
    this.setState({
      eyeShow: true,
    });
  };

  handleDeleteFile = e => {
    const { onDelete, handleDelete, type } = this.props;

    onDelete(e);
    if (handleDelete && type === 'video') {
      handleDelete();
    }
  };

  render() {
    const { onCancel, onReload, t, handlePause, handleRestart, handleContinue, status } =
      this.props;
    const { progress, transcodedStatus, uploadState } = this.state;

    return (
      <div
        className={classNames(
          'photo-item__img-container',
          this.props.parentType === 'library' ? 'photo-item__img-container--library' : '',
          this.props.isSingle
            ? 'photo-item__img-container--single'
            : 'photo-item__img-container--multiple',
          this.props.className,
        )}
        role="button"
        tabIndex="0"
        onMouseOver={this.toggleShowEye}
        onMouseLeave={this.toggleHideEye}
        onDoubleClick={this.props.viewGallery}
      >
        <If
          condition={
            status === propertyDraftStatus.REJECTED || status === propertyDraftStatus.PENDING
          }
        >
          <span
            className={classNames('photo-item__status-wrap', {
              'photo-item__status-wrap--rejected': status === propertyDraftStatus.REJECTED,
              'photo-item__status-wrap--pending': status === propertyDraftStatus.PENDING,
            })}
          >
            <Choose>
              <When condition={status === propertyDraftStatus.REJECTED}>
                <RejectedNoShadowIcon className="photo-item__rejected-tag" />
              </When>
              <When condition={status === propertyDraftStatus.PENDING}>
                <PendingNoShadowIcon className="photo-item__pending-tag" />
              </When>
            </Choose>
          </span>
        </If>
        <If condition={this.props.type === 'image'}>
          <img
            src={this.props.src}
            alt=""
            className={this.props.isSingle ? 'photo-item__img-single' : 'photo-item__img-multiple'}
          />
          <div
            className={classNames('photo-item__image-progress-wrapper', {
              'photo-item__image-progress-wrapper--show':
                uploadState && uploadState !== uploadStatus.SUCCESS,
            })}
          >
            <If condition={uploadState !== uploadStatus.SUCCESS}>
              <div className="photo-item__image-progress">
                <If condition={uploadState === uploadStatus.IN_PROGRESS}>
                  <button className="photo-item__image-progress-button" onClick={onCancel}>
                    <PauseOutlined className="photo-item__image-pause-icon" />
                  </button>
                </If>
                <If condition={uploadState === uploadStatus.FAILED}>
                  <button className="photo-item__image-progress-button" onClick={onReload}>
                    <ReloadOutlined className="photo-item__image-reload-icon" />
                  </button>
                </If>
                <If condition={uploadState}>
                  <ProgressBar
                    progress={progress}
                    uploadState={uploadState}
                    className="photo-item__image-progress-bar"
                    t={this.props.t}
                    type="image"
                  />
                </If>
              </div>
            </If>
          </div>
          <If condition={this.props.isCover}>
            <CoverIcon className="photo-item__cover" />
          </If>
        </If>
        <If condition={this.props.type === 'pdf'}>
          <If condition={status === 'REJECTED'}>
            <span className="photo-item__reject-photo">
              <RejectedNoShadowIcon className="photo-item__reject-photo__icon" />
            </span>
          </If>
          <div
            className={this.props.isSingle ? 'photo-item__img-single' : 'photo-item__img-multiple'}
          >
            <embed className="photo-item__pdf" src={this.props.src} />
          </div>
          <div
            className={classNames('photo-item__image-progress-wrapper', {
              'photo-item__image-progress-wrapper--show':
                uploadState && uploadState !== uploadStatus.SUCCESS,
            })}
          >
            <If condition={uploadState !== uploadStatus.SUCCESS}>
              <div className="photo-item__image-progress">
                <If condition={uploadState === uploadStatus.IN_PROGRESS}>
                  <button className="photo-item__image-progress-button" onClick={onCancel}>
                    <PauseOutlined className="photo-item__image-pause-icon" />
                  </button>
                </If>
                <If condition={uploadState === uploadStatus.FAILED}>
                  <button className="photo-item__image-progress-button" onClick={onReload}>
                    <ReloadOutlined className="photo-item__image-reload-icon" />
                  </button>
                </If>
                <If condition={uploadState}>
                  <ProgressBar
                    progress={progress}
                    uploadState={uploadState}
                    className="photo-item__image-progress-bar"
                    t={this.props.t}
                    type="image"
                  />
                </If>
              </div>
            </If>
          </div>
        </If>
        <If condition={this.props.type === 'video'}>
          <span className="photo-item__video-tag-wrap">
            <VideoCameraOutlined className="photo-item__video-icon" />
            <span className="photo-item__video-tag">
              {t('cms:cms.property.listing_management.video.tag')}
            </span>
          </span>
          <Choose>
            <When condition={uploadState && uploadState !== uploadStatus.SUCCESS}>
              <div className="photo-item__video-progress-wrapper">
                <div className="photo-item__video-progress">
                  <If condition={uploadState === uploadStatus.IN_PROGRESS}>
                    <button className="photo-item__video-progress-button" onClick={handlePause}>
                      <PauseOutlined className="photo-item__video-pause-icon" />
                    </button>
                  </If>
                  <If condition={uploadState === uploadStatus.PAUSE}>
                    <button className="photo-item__video-progress-button" onClick={handleContinue}>
                      <RightOutlined className="photo-item__continue-icon" />
                    </button>
                  </If>
                  <If condition={uploadState === uploadStatus.FAILED}>
                    <button className="photo-item__video-progress-button" onClick={handleRestart}>
                      <ReloadOutlined className="photo-item__video-reload-icon" />
                    </button>
                  </If>

                  <If condition={uploadState}>
                    <ProgressBar
                      progress={progress}
                      uploadState={uploadState}
                      className="photo-item__video-progress-bar"
                      t={this.props.t}
                      type="video"
                    />
                  </If>
                </div>
              </div>
            </When>
            <Otherwise>
              <Choose>
                <When condition={transcodedStatus === gallery.videoStatus.waitCompress}>
                  <div className="photo-item__img-video-compress">
                    <Tooltip
                      placement={'top'}
                      title={this.props.t('cms:cms.properties.edit.gallery.publishing_text')}
                    >
                      <div className="photo-item__img-video-compress--hover">
                        <VideoCameraOutlined className="photo-item__img-video-icon" />
                        <span>{this.props.t('cms:cms.properties.edit.gallery.file_type.mp4')}</span>
                      </div>
                    </Tooltip>
                  </div>
                </When>
                <When condition={transcodedStatus === gallery.videoStatus.compressing}>
                  <div className="photo-item__img-video-compress">
                    <Tooltip
                      placement={'top'}
                      title={this.props.t('cms:cms.properties.edit.gallery.compressing_text')}
                    >
                      <div className="photo-item__img-video-compress--hover">
                        <HourglassIcon className="photo-item__img-video-icon" />
                        <span>
                          {this.props.t(
                            'cms:cms.properties.edit.gallery.video_is_compressing.text',
                          )}
                        </span>
                      </div>
                    </Tooltip>
                  </div>
                </When>
                <When condition={transcodedStatus === gallery.videoStatus.error}>
                  <div className="photo-item__img-video-compress photo-item__img-video-compress-err">
                    <Tooltip
                      placement={'top'}
                      title={this.props.t('cms:cms.properties.edit.gallery.failed_text')}
                    >
                      <div className="photo-item__img-video-compress--hover">
                        <VideoFailedIcon className="photo-item__img-video-icon" />
                        <span>{this.props.t('cms:cms.properties.edit.gallery.file_type.mp4')}</span>
                      </div>
                    </Tooltip>
                  </div>
                </When>
                <Otherwise>
                  <div className="photo-item__img-video-success">
                    <PlayCircleOutlined className="photo-item__video-play-icon" />
                    <img src={this.props.src} alt="" className="photo-item__img-multiple" />
                  </div>
                </Otherwise>
              </Choose>
            </Otherwise>
          </Choose>
          <div className="photo-item__video-locale">
            <span className="photo-item__locale-label">
              {t('cms:cms.property.listing_management.video_locale.label')}
            </span>
            <Select
              className="photo-item__video-locale-selection"
              defaultValue={localeMapping.ALL}
              onChange={e => this.props.onChangeLocale(e)}
              value={this.props.locales}
            >
              <For each="locale" of={['ALL', 'CN', 'ROW']}>
                <Option key={locale} value={localeMapping[locale]} title={locale}>
                  {locale}
                </Option>
              </For>
            </Select>
          </div>
        </If>
        <If condition={this.state.eyeShow}>
          <div
            className={classNames(
              'photo-item__img-eye-modal',
              this.state.eyeShow ? 'photo-item__img-eye-fade-in' : 'photo-item__img-eye-fade-out',
            )}
            onClick={e => {
              if (this.props.type === 'pdf') {
                window.open(this.props.src);
              } else {
                this.props.viewGallery(e);
              }
            }}
            role="button"
            tabIndex="0"
          >
            <EyeOutlined className={'photo-item__img-eye-icon'} />
          </div>
          <button
            className={classNames(
              'photo-item__image-button-delete',
              this.state.eyeShow ? 'photo-item__img-eye-fade-in' : 'photo-item__img-eye-fade-out',
            )}
            onClick={this.handleDeleteFile}
          >
            <DeleteOutlined className="photo-item__image-delete-icon" />
          </button>
        </If>
      </div>
    );
  }
}

PhotoItem.propTypes = {
  t: PropTypes.func,
  type: PropTypes.oneOf(['image', 'video', 'pdf']),
  className: PropTypes.string,
  isSingle: PropTypes.bool,
  isCover: PropTypes.bool,
  src: PropTypes.string,
  uploadState: PropTypes.string,
  status: PropTypes.string,
  viewGallery: PropTypes.func.isRequired,
  parentType: PropTypes.string,
  transcodedStatus: PropTypes.string,
  progress: PropTypes.number,
  onDelete: PropTypes.func,
  onCancel: PropTypes.func,
  onReload: PropTypes.func,
  onChangeLocale: PropTypes.func,
  locales: PropTypes.string,
  handleDelete: PropTypes.func,
  handlePause: PropTypes.func,
  handleRestart: PropTypes.func,
  handleContinue: PropTypes.func,
};

PhotoItem.defaultProps = {
  t: () => {},
  type: 'image',
  className: '',
  src: '',
  isSingle: false,
  isCover: false,
  uploadState: '',
  status: '',
  parentType: '',
  transcodedStatus: '',
  progress: 0,
  onDelete: () => {},
  onCancel: () => {},
  onReload: () => {},
  onChangeLocale: () => {},
  locales: '',
  handleDelete: () => {},
  handlePause: () => {},
  handleRestart: () => {},
  handleContinue: () => {},
};
